import React from "react"

type Props = {
  className?: string
  pathClassName?: string
}

const LockIcon = ({ className, pathClassName }: Props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={21}
      height={20}
      fill="none"
      className={className}
    >
      <path
        stroke="currentColor"
        className={pathClassName}
        d="M14.668 17.5H6.335c-.921 0-1.667-.746-1.667-1.667V10c0-.921.746-1.667 1.667-1.667h8.333c.92 0 1.667.746 1.667 1.667v5.833c0 .92-.746 1.667-1.667 1.667ZM7.168 8.333v-2.5a3.333 3.333 0 0 1 6.667 0v2.5"
      />
    </svg>
  )
}

export default LockIcon
